import React, { Component } from 'react';
import styled from 'styled-components';
import { Flex, media } from 'lib/style-utils';
import ScrollDown from './ScrollDown';
import Spinner from 'react-md-spinner';
import scrollToComponent from 'react-scroll-to-component';

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  background: ${props => props.color};
  overflow: hidden;

  ${media.iphone67p`
    height: 696px;
  `}
  ${media.iphone67`
    height: 627px;
  `}
`;

const TopWrapper = Flex.extend`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 3000px;
  height: 100vh;
  overflow: hidden;

  ${media.iphone67p`
    height: 633px;
  `}
  ${media.iphone67`
    height: 583px;
  `}
`;

const CircleImg = styled.div`
  width: calc(100vh / 2);
  height: calc(100vh / 2);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: 50%;
  z-index: 10;
`;

const Left = CircleImg.extend`
  background-image: url(${props => props.src});

  ${media.iphone67p`
    display: none;
  `}
`;

const Right = CircleImg.extend`
  background-image: url(${props => props.src});

  ${media.iphone67p`
    display: none;
  `}
`;

const Middle = CircleImg.extend`
  width: 100vh;
  height: 100vh;
  background-image: url(${props => props.src});

  ${media.iphone67p`
    position: absolute;
    top: 98px;
    left: 50%;
    transform: translateX(-50%);
    width: 380px;
    height: 380px;
  `}
  ${media.iphone67`
    width: 335px;
    height: 335px;
  `}
`;

const Title = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 48px;
  font-weight: 700;
  letter-spacing: 7.6px;
  color: ${props => props.color === '#ffffff' ? '#000000' : '#ffffff'};
  z-index: 10;
  text-shadow: 1px 1px 10px rgba(0,0,0,0.4);

  ${media.iphone67p`
    top: 530px;
    font-size: 28px;
    letter-spacing: 5.2px;
  `}
  ${media.iphone67`
    top: 480px;
  `}
`;

const Span = styled.span`
  font-size: 24px;
  letter-spacing: 3.2px;

  ${media.iphone67p`
    font-size: 16px;
    letter-spacing: 3.2px;
  `}
`;

const SpinnerWrapper = Flex.extend`
  height: 100vh;
`;

class Top extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    return this.props !== nextProps;
  }

  handleScrollDown = () => {
    const innerHeight = window.innerHeight;

    scrollToComponent(document.body, {
        offset: innerHeight - 30,
        align: 'top',
        duration: 1000,
    });
  }

  render() {
    const { handleScrollDown } = this;
    const { color, loading } = this.props;
    const { aboutImagesLeft, aboutImagesMiddle, aboutImagesRight } = this.props.homeData;

    return (
      <Wrapper color={color}>
        <TopWrapper>
          <Left src={aboutImagesLeft && aboutImagesLeft.url}/>

          {
            loading ? (
              <SpinnerWrapper>
                <Spinner size="60px"/>
              </SpinnerWrapper>
            ) : (
              <div>
                <Middle src={aboutImagesMiddle && aboutImagesMiddle.url}/>
                <Title color={color}>ABOUT<br/><Span>BABY DEEDEE</Span></Title>
              </div>
            )
          }

          <Right src={aboutImagesRight && aboutImagesRight.url}/>
        </TopWrapper>
        <ScrollDown color={color} onClick={handleScrollDown}>
          <span></span>
        </ScrollDown>
      </Wrapper>
    );
  }
};

export default Top;



// WEBPACK FOOTER //
// ./src/components/About/Top.js